// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_cmp_jstf_to_svg = require("../explorer/MM_cmp_jstf_to_svg.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Edit = require("@mui/icons-material/Edit").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var ButtonGroup = require("@mui/material/ButtonGroup").default;
var FormControl = require("@mui/material/FormControl").default;
var Logout = require("@mui/icons-material/Logout").default;
var ZoomInMap = require("@mui/icons-material/ZoomInMap").default;
var ZoomOutMap = require("@mui/icons-material/ZoomOutMap").default;
var ContentCopy = require("@mui/icons-material/ContentCopy").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  return React.createElement("span", {
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: color,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function setNewText(st, text) {
  return {
          newText: text,
          infoExpanded: st.infoExpanded
        };
}

function setInfoExpanded(st, infoExpanded) {
  return {
          newText: st.newText,
          infoExpanded: infoExpanded
        };
}

function leftClickHnd(clbk, mouseEvt) {
  if (mouseEvt.button === 0 && !mouseEvt.altKey && !mouseEvt.ctrlKey && !mouseEvt.shiftKey) {
    return Curry._1(clbk, undefined);
  }
  
}

function altLeftClickHnd(clbk, mouseEvt) {
  if (mouseEvt.button === 0 && mouseEvt.altKey && !mouseEvt.ctrlKey && !mouseEvt.shiftKey) {
    return Curry._1(clbk, undefined);
  }
  
}

function textToSyntaxTree(wrkCtx, syms, syntaxTypes, frms, parenCnt, lastSyntaxType, onLastSyntaxTypeChange) {
  if (syntaxTypes.length === 0) {
    return {
            TAG: /* Error */1,
            _0: "Could not determine syntax types."
          };
  }
  var match = syms.find(function (stmtSym) {
        return Belt_Option.isNone(MM_context.ctxSymToInt(wrkCtx, stmtSym.sym));
      });
  if (match !== undefined) {
    return {
            TAG: /* Error */1,
            _0: "The statement contains an unrecognized symbol: '" + match.sym + "'"
          };
  }
  var lastSyntaxTypeInt = Belt_Option.getWithDefault(Belt_Option.flatMap(lastSyntaxType, (function (param) {
              return MM_context.ctxSymToInt(wrkCtx, param);
            })), 0);
  var syntaxTypes$1 = syntaxTypes.slice().sort(function (a, b) {
        if (a === lastSyntaxTypeInt) {
          return -1;
        } else if (b === lastSyntaxTypeInt) {
          return 1;
        } else {
          return a - b | 0;
        }
      });
  var stmt = MM_context.ctxSymsToIntsExn(wrkCtx, syms.map(function (stmtSym) {
            return stmtSym.sym;
          }));
  var expr = stmt.slice(1);
  var proofTree = MM_provers.proveSyntaxTypes(undefined, Caml_option.some(wrkCtx), Caml_option.some(frms), Caml_option.some(parenCnt), [expr], syntaxTypes$1, undefined, undefined);
  var node = MM_proof_tree.ptGetSyntaxProof(proofTree, expr);
  if (node === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Could not prove this statement is of any of the types: " + MM_context.ctxIntsToStrExn(wrkCtx, syntaxTypes$1) + ""
          };
  }
  var node$1 = Caml_option.valFromOption(node);
  var match$1 = MM_context.ctxIntToSym(wrkCtx, Caml_array.get(MM_proof_tree.pnGetExpr(node$1), 0));
  if (lastSyntaxType !== undefined) {
    if (match$1 !== undefined && lastSyntaxType !== match$1) {
      Curry._1(onLastSyntaxTypeChange, match$1);
    }
    
  } else if (match$1 !== undefined) {
    Curry._1(onLastSyntaxTypeChange, match$1);
  }
  return MM_syntax_tree.buildSyntaxTreeFromProofTree(wrkCtx, proofTree, MM_proof_tree.pnGetExpr(node$1));
}

function rndSymbol(isFirst, key, sym, color, onClick, spaceBackgroundColor, symbolBackgroundColor, cursorOpt, param) {
  var cursor = cursorOpt !== undefined ? cursorOpt : "auto";
  var tmp;
  if (isFirst) {
    tmp = null;
  } else {
    var tmp$1 = {
      cursor: cursor
    };
    if (spaceBackgroundColor !== undefined) {
      tmp$1.backgroundColor = spaceBackgroundColor;
    }
    tmp = React.createElement("span", {
          style: tmp$1,
          onClick: onClick
        }, " ");
  }
  var match = color !== undefined ? [
      color,
      "bold"
    ] : [
      "black",
      "normal"
    ];
  var tmp$2 = {
    color: match[0],
    cursor: cursor,
    fontWeight: match[1]
  };
  if (symbolBackgroundColor !== undefined) {
    tmp$2.backgroundColor = symbolBackgroundColor;
  }
  return JsxPPXReactSupport.createElementVariadicWithKey(key, React.Fragment, {
              children: null
            }, [
              tmp,
              React.createElement("span", {
                    style: tmp$2,
                    onClick: onClick
                  }, sym)
            ]);
}

function rndContText(stmtCont, onTextClick, onTreeClick, editStmtsByLeftClickOpt, renderSelectionOpt, param) {
  var editStmtsByLeftClick = editStmtsByLeftClickOpt !== undefined ? editStmtsByLeftClickOpt : true;
  var renderSelection = renderSelectionOpt !== undefined ? renderSelectionOpt : false;
  if (stmtCont.TAG === /* Text */0) {
    var onClick = function (idx) {
      return Belt_Option.map(onTextClick, (function (onTextClick) {
                    if (editStmtsByLeftClick) {
                      return function (param) {
                        return altLeftClickHnd((function (param) {
                                      Curry._1(onTextClick, idx);
                                    }), param);
                      };
                    } else {
                      return function (param) {
                        return leftClickHnd((function (param) {
                                      Curry._1(onTextClick, idx);
                                    }), param);
                      };
                    }
                  }));
    };
    var cursor = editStmtsByLeftClick ? "auto" : "pointer";
    return stmtCont._0.map(function (stmtSym, i) {
                return rndSymbol(i === 0, String(i), stmtSym.sym, stmtSym.color, onClick(i), undefined, undefined, cursor, undefined);
              });
  }
  var match = stmtCont._0;
  var onClick$1 = function (id) {
    return Belt_Option.map(onTreeClick, (function (onTreeClick) {
                  if (editStmtsByLeftClick) {
                    return function (param) {
                      return altLeftClickHnd((function (param) {
                                    Curry._1(onTreeClick, id);
                                  }), param);
                    };
                  } else {
                    return function (param) {
                      return leftClickHnd((function (param) {
                                    Curry._1(onTreeClick, id);
                                  }), param);
                    };
                  }
                }));
  };
  var cursor$1 = editStmtsByLeftClick ? "auto" : "pointer";
  var match$1 = MM_wrk_editor.getIdsOfSelectedNodes(stmtCont);
  var selectedIds = match$1[1];
  var clickedId = match$1[0];
  var elems = [];
  elems.push(rndSymbol(true, "expr-type", match.exprTyp, undefined, undefined, undefined, undefined, cursor$1, undefined));
  Expln_utils_data.traverseTree({
        contents: false
      }, {
        TAG: /* Subtree */0,
        _0: match.root
      }, (function (param, node) {
          if (node.TAG === /* Subtree */0) {
            return node._0.children;
          }
          
        }), undefined, (function (selectionIsOn, node) {
          if (node.TAG !== /* Subtree */0) {
            var id = node.id;
            var symbolIsHighlighted = Belt_SetInt.has(selectedIds, id);
            elems.push(rndSymbol(false, String(id), node.sym, node.color, onClick$1(id), renderSelection && symbolIsHighlighted && selectionIsOn.contents ? "#ADD6FF" : undefined, renderSelection && symbolIsHighlighted ? (
                        id === clickedId ? "#99bce0" : "#ADD6FF"
                      ) : undefined, cursor$1, undefined));
            selectionIsOn.contents = symbolIsHighlighted;
          }
          
        }), undefined, undefined);
  return elems;
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

function rndProofStatus(proofStatus, readyTooltip, waitingTooltip, noJstfTooltip, jstfIsIncorrectTooltip, onReadyIconClicked, onErrorIconClicked, onNoJstfIconClicked, param) {
  var commonStyle = {
    display: "inline-block",
    fontWeight: "bold",
    width: "13px"
  };
  if (proofStatus === undefined) {
    return React.createElement("span", {
                style: commonStyle
              }, Common.nbsp);
  }
  switch (proofStatus) {
    case /* Ready */0 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "green",
                          cursor: Belt_Option.isSome(onReadyIconClicked) ? "pointer" : "default"
                        }),
                    title: readyTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onReadyIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "\u2713");
    case /* Waiting */1 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "orange"
                        }),
                    title: waitingTooltip
                  }, "\u223F");
    case /* NoJstf */2 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "red",
                          cursor: Belt_Option.isSome(onNoJstfIconClicked) ? "pointer" : "default"
                        }),
                    title: noJstfTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onNoJstfIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "?");
    case /* JstfIsIncorrect */3 :
        return React.createElement("span", {
                    style: Object.assign({}, commonStyle, {
                          color: "red",
                          cursor: Belt_Option.isSome(onErrorIconClicked) ? "pointer" : "default"
                        }),
                    title: jstfIsIncorrectTooltip,
                    onClick: (function (param) {
                        Belt_Option.forEach(onErrorIconClicked, (function (clbk) {
                                Curry._1(clbk, undefined);
                              }));
                      })
                  }, "\u2717");
    
  }
}

var make = React.memo((function (param) {
        var typeColors = param.typeColors;
        var src = param.src;
        var proofTreeDto = param.proofTreeDto;
        var wrkCtx = param.wrkCtx;
        var match = MM_wrk_editor.parseJstf(param.jstfText);
        if (match.TAG !== /* Ok */0) {
          return null;
        }
        var jstf = match._0;
        if (jstf === undefined) {
          return null;
        }
        if (typeof src === "number") {
          return null;
        }
        if (src.TAG !== /* Assertion */1) {
          return null;
        }
        var args = src.args;
        var frame = MM_context.getFrame(wrkCtx, src.label);
        if (frame === undefined) {
          return null;
        }
        var asrt = MM_context.frmIntsToSymsExn(wrkCtx, frame, frame.asrt);
        var hyps = [];
        var subs = Belt_HashMapString.make(frame.hyps.length);
        var frmColors = Belt_HashMapString.make(frame.hyps.length);
        frame.hyps.forEach(function (hyp, i) {
              if (hyp.typ === /* E */1) {
                hyps.push(MM_context.frmIntsToSymsExn(wrkCtx, frame, hyp.expr));
                return ;
              }
              var frmSym = MM_context.frmIntToSymExn(wrkCtx, frame, Caml_array.get(hyp.expr, 1));
              Belt_HashMapString.set(subs, frmSym, MM_context.ctxIntsToSymsExn(wrkCtx, Caml_array.get(proofTreeDto.nodes, Caml_array.get(args, i)).expr.slice(1)));
              var typeSym = MM_context.ctxIntToSymExn(wrkCtx, Caml_array.get(hyp.expr, 0));
              var color = Belt_HashMapString.get(typeColors, typeSym);
              if (color !== undefined) {
                return Belt_HashMapString.set(frmColors, frmSym, color);
              }
              
            });
        return React.createElement(MM_cmp_jstf_to_svg.make, {
                    hyps: hyps,
                    hypLabels: jstf.args,
                    asrt: asrt,
                    subs: subs,
                    frmColors: Caml_option.some(frmColors),
                    ctxColors1: Caml_option.some(param.preCtxColors),
                    ctxColors2: Caml_option.some(param.wrkCtxColors)
                  });
      }), (function (param, param$1) {
        return true;
      }));

function propsAreSame(a, b) {
  if (a.settingsVer === b.settingsVer && a.preCtxVer === b.preCtxVer && a.varsText === b.varsText && a.visualizationIsOn === b.visualizationIsOn && a.stmt.label === b.stmt.label && a.stmt.labelEditMode === b.stmt.labelEditMode && a.stmt.typ === b.stmt.typ && a.stmt.typEditMode === b.stmt.typEditMode && a.stmt.cont === b.stmt.cont && a.stmt.contEditMode === b.stmt.contEditMode && a.stmt.jstfText === b.stmt.jstfText && a.stmt.jstfEditMode === b.stmt.jstfEditMode && Caml_obj.equal(a.stmt.src, b.stmt.src)) {
    return a.stmt.proofStatus === b.stmt.proofStatus;
  } else {
    return false;
  }
}

var make$1 = React.memo((function (param) {
        var addStmtBelow = param.addStmtBelow;
        var addStmtAbove = param.addStmtAbove;
        var onDebug = param.onDebug;
        var onJstfEditCancel = param.onJstfEditCancel;
        var onJstfEditDone = param.onJstfEditDone;
        var onJstfEditRequested = param.onJstfEditRequested;
        var onSyntaxTreeUpdated = param.onSyntaxTreeUpdated;
        var onContEditCancel = param.onContEditCancel;
        var onContEditDone = param.onContEditDone;
        var onContEditRequested = param.onContEditRequested;
        var onTypEditDone = param.onTypEditDone;
        var onTypEditRequested = param.onTypEditRequested;
        var onLabelEditCancel = param.onLabelEditCancel;
        var onLabelEditDone = param.onLabelEditDone;
        var onLabelEditRequested = param.onLabelEditRequested;
        var stmt = param.stmt;
        var visualizationIsOn = param.visualizationIsOn;
        var defaultStmtType = param.defaultStmtType;
        var editStmtsByLeftClick = param.editStmtsByLeftClick;
        var wrkCtxColors = param.wrkCtxColors;
        var preCtxColors = param.preCtxColors;
        var typeColors = param.typeColors;
        var parensMap = param.parensMap;
        var syntaxTypes = param.syntaxTypes;
        var parenCnt = param.parenCnt;
        var frms = param.frms;
        var wrkCtx = param.wrkCtx;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return {
                      newText: "",
                      infoExpanded: false
                    };
            });
        var setState = match[1];
        var state = match[0];
        var labelRef = React.useRef(null);
        var stmtTextFieldRef = React.useRef(null);
        var match$1 = React.useState(function () {
              
            });
        var setSyntaxTreeWasRequested = match$1[1];
        var syntaxTreeWasRequested = match$1[0];
        var match$2 = React.useState(function () {
              
            });
        var setSyntaxTreeError = match$2[1];
        var syntaxTreeError = match$2[0];
        var match$3 = React.useState(function () {
              
            });
        var setSelectionRange = match$3[1];
        var selectionRange = match$3[0];
        var match$4 = React.useState(function () {
              
            });
        var setCopiedToClipboard = match$4[1];
        var copiedToClipboard = match$4[0];
        var match$5 = React.useState(function () {
              
            });
        var setNewTextCursorPosition = match$5[1];
        var newTextCursorPosition = match$5[0];
        React.useEffect((function () {
                if (stmt.labelEditMode) {
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, stmt.label);
                        }));
                } else if (stmt.typEditMode) {
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, MM_wrk_editor.userStmtTypeToStr(stmt.typ));
                        }));
                } else if (stmt.contEditMode) {
                  var contStr = MM_wrk_editor.contToStr(stmt.cont);
                  var contStr$1 = contStr === "" && defaultStmtType !== "" ? defaultStmtType + " " : contStr;
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, contStr$1);
                        }));
                } else if (stmt.jstfEditMode) {
                  Curry._1(setState, (function (__x) {
                          return setNewText(__x, stmt.jstfText);
                        }));
                }
                
              }), [
              stmt.labelEditMode,
              stmt.typEditMode,
              stmt.contEditMode,
              stmt.jstfEditMode
            ]);
        React.useEffect((function () {
                if (syntaxTreeError !== undefined) {
                  Curry._1(setSyntaxTreeError, (function (param) {
                          
                        }));
                  MM_react_common.openInfoDialog(modalRef, syntaxTreeError, undefined, undefined);
                }
                
              }), [syntaxTreeError]);
        React.useEffect((function () {
                var domElem = stmtTextFieldRef.current;
                if (!(domElem == null) && selectionRange !== undefined) {
                  Curry._1(setSelectionRange, (function (param) {
                          
                        }));
                  domElem.setSelectionRange(selectionRange[0], selectionRange[1]);
                }
                
              }), [stmtTextFieldRef.current]);
        React.useEffect((function () {
                if (newTextCursorPosition !== undefined) {
                  Curry._1(setNewTextCursorPosition, (function (param) {
                          
                        }));
                  var domElem = stmtTextFieldRef.current;
                  if (!(domElem == null)) {
                    domElem.selectionStart = newTextCursorPosition;
                    domElem.selectionEnd = newTextCursorPosition;
                  }
                  
                }
                
              }), [newTextCursorPosition]);
        React.useEffect((function () {
                if (syntaxTreeWasRequested !== undefined) {
                  Common.$$setTimeout((function (param) {
                          Curry._1(setSyntaxTreeWasRequested, (function (param) {
                                  
                                }));
                          var lastSyntaxTypeLocStorKey = "editor-last-syntax-type";
                          if (wrkCtx === undefined) {
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return "Cannot build a syntax tree because there was an error setting MM context.";
                                        }));
                          }
                          var syms = stmt.cont;
                          if (syms.TAG !== /* Text */0) {
                            return Curry._1(setSyntaxTreeError, (function (param) {
                                          return "Cannot build a syntax tree because stmtCont is a tree.";
                                        }));
                          }
                          var syms$1 = syms._0;
                          var msg = textToSyntaxTree(Caml_option.valFromOption(wrkCtx), syms$1, syntaxTypes, frms, parenCnt, Local_storage_utils.locStorReadString(lastSyntaxTypeLocStorKey), (function (__x) {
                                  Local_storage_utils.locStorWriteString(lastSyntaxTypeLocStorKey, __x);
                                }));
                          if (msg.TAG === /* Ok */0) {
                            var syntaxTree = msg._0;
                            return Curry._1(onSyntaxTreeUpdated, {
                                        TAG: /* Tree */1,
                                        _0: {
                                          exprTyp: Caml_array.get(syms$1, 0).sym,
                                          root: MM_wrk_editor.addColorsToSyntaxTree(syntaxTree, preCtxColors, wrkCtxColors),
                                          clickedNodeId: MM_wrk_editor.getNodeIdBySymIdx(syntaxTreeWasRequested, syntaxTree),
                                          expLvl: 0
                                        }
                                      });
                          }
                          var msg$1 = msg._0;
                          Curry._1(setSyntaxTreeError, (function (param) {
                                  return msg$1;
                                }));
                        }), 0);
                }
                
              }), [syntaxTreeWasRequested]);
        var actToggleInfoExpanded = function (param) {
          Curry._1(setState, (function (st) {
                  return setInfoExpanded(st, !st.infoExpanded);
                }));
        };
        var actNewTextUpdated = function (newText) {
          Curry._1(setState, (function (__x) {
                  return setNewText(__x, newText);
                }));
        };
        var after = function (str, pos) {
          return str.substring(pos + 1 | 0);
        };
        var getLastSymbol = function (str) {
          var idx = str.lastIndexOf(" ");
          if (idx !== -1) {
            return str.substring(idx + 1 | 0);
          } else {
            return str;
          }
        };
        var actLabelEditDone = function (param) {
          Curry._1(onLabelEditDone, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
        };
        var actLabelEditCancel = function (param) {
          Curry._1(onLabelEditCancel, state.newText.replace(symbolsNotAllowedInLabelRegex, ""));
        };
        var actTypEditDone = function (newTypStr) {
          Curry._1(onTypEditDone, MM_wrk_editor.userStmtTypeFromStr(newTypStr));
        };
        var actContEditDone = function (param) {
          Curry._1(onContEditDone, state.newText.trim());
        };
        var actContEditCancel = function (param) {
          Curry._1(onContEditCancel, state.newText.trim());
        };
        var actJstfEditDone = function (param) {
          Curry._1(setState, (function (st) {
                  return setInfoExpanded(st, true);
                }));
          Curry._1(onJstfEditDone, state.newText.trim());
        };
        var actJstfEditCancel = function (param) {
          Curry._1(onJstfEditCancel, state.newText.trim());
        };
        var actJstfDeleted = function (param) {
          Curry._1(onJstfEditDone, "");
        };
        var actUpdateSyntaxTree = function (update) {
          var treeData = stmt.cont;
          if (treeData.TAG === /* Text */0) {
            return ;
          } else {
            return Curry._1(onSyntaxTreeUpdated, {
                        TAG: /* Tree */1,
                        _0: Curry._1(update, treeData._0)
                      });
          }
        };
        var actTreeNodeClicked = function (nodeId) {
          actUpdateSyntaxTree(function (treeData) {
                return {
                        exprTyp: treeData.exprTyp,
                        root: treeData.root,
                        clickedNodeId: nodeId,
                        expLvl: 0
                      };
              });
        };
        var updateExpLavel = function (treeData, inc) {
          var update = inc ? MM_wrk_editor.incExpLvl : MM_wrk_editor.decExpLvl;
          var prevTreeData = treeData;
          var prevNum = MM_wrk_editor.getNumberOfSelectedSymbols(prevTreeData);
          var newTreeData = Curry._1(update, prevTreeData);
          var newNum = MM_wrk_editor.getNumberOfSelectedSymbols(newTreeData);
          while(prevNum === newNum && (inc && newTreeData.expLvl < newTreeData.root.height || !inc && newTreeData.expLvl > 0)) {
            prevTreeData = newTreeData;
            prevNum = MM_wrk_editor.getNumberOfSelectedSymbols(prevTreeData);
            newTreeData = Curry._1(update, prevTreeData);
            newNum = MM_wrk_editor.getNumberOfSelectedSymbols(newTreeData);
          };
          return newTreeData;
        };
        var rndLabel = function (param) {
          if (!stmt.labelEditMode) {
            return React.createElement("span", {
                        ref: Caml_option.some(labelRef),
                        style: {
                          whiteSpace: "nowrap",
                          overflowWrap: "normal"
                        },
                        title: "<left-click> to change",
                        onClick: (function (param) {
                            return leftClickHnd(onLabelEditRequested, param);
                          })
                      }, stmt.label);
          }
          var partial_arg = actLabelEditCancel;
          var partial_arg$1 = actLabelEditDone;
          return React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(TextField, {
                          value: state.newText,
                          size: "small",
                          style: {
                            width: "100px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (str) {
                                            var newText = str.replace(symbolsNotAllowedInLabelRegex, "");
                                            Curry._1(setState, (function (__x) {
                                                    return setNewText(__x, newText);
                                                  }));
                                          }), param);
                            }),
                          onKeyDown: (function (param) {
                              return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                            }),
                          autoFocus: true,
                          title: "Enter to save, Esc to cancel"
                        }), rndIconButton(React.createElement(Save, {}), actLabelEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actLabelEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
        };
        var rndSelectionButtons = function (param) {
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      children: Caml_option.some(null)
                    }, React.createElement(ButtonGroup, {
                          variant: "outlined",
                          size: "small",
                          children: null
                        }, React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTree(function (__x) {
                                        return updateExpLavel(__x, true);
                                      });
                                }),
                              title: "Expand selection",
                              children: Caml_option.some(React.createElement(ZoomOutMap, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTree(function (__x) {
                                        return updateExpLavel(__x, false);
                                      });
                                }),
                              title: "Shrink selection",
                              children: Caml_option.some(React.createElement(ZoomInMap, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  Belt_Option.forEach(MM_wrk_editor.getSelectedText(stmt.cont), (function (selectedText) {
                                          var match = stmt.cont;
                                          if (match.TAG === /* Text */0) {
                                            return ;
                                          } else {
                                            return Curry._1(addStmtAbove, match._0.exprTyp + " " + selectedText);
                                          }
                                        }));
                                }),
                              title: "Add new statement above",
                              children: Caml_option.some(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(-90deg)"
                                        }
                                      }))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  Belt_Option.forEach(MM_wrk_editor.getSelectedText(stmt.cont), (function (selectedText) {
                                          var match = stmt.cont;
                                          if (match.TAG === /* Text */0) {
                                            return ;
                                          } else {
                                            return Curry._1(addStmtBelow, match._0.exprTyp + " " + selectedText);
                                          }
                                        }));
                                }),
                              title: "Add new statement below",
                              children: Caml_option.some(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(90deg)"
                                        }
                                      }))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  var syms = MM_wrk_editor.getSelectedSymbols(stmt.cont);
                                  if (syms !== undefined) {
                                    MM_react_common.copyToClipboard(syms.join(" "));
                                    return Curry._1(setCopiedToClipboard, (function (timerId) {
                                                  if (timerId !== undefined) {
                                                    Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                                  }
                                                  return Caml_option.some(Common.$$setTimeout((function (param) {
                                                                    Curry._1(setCopiedToClipboard, (function (param) {
                                                                            
                                                                          }));
                                                                  }), 1000));
                                                }));
                                  }
                                  
                                }),
                              title: "Copy to the clipboard",
                              children: Caml_option.some(React.createElement(ContentCopy, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  Curry._1(setSelectionRange, (function (param) {
                                          var match = stmt.cont;
                                          if (match.TAG === /* Text */0) {
                                            return ;
                                          }
                                          var match$1 = match._0;
                                          var match$2 = MM_wrk_editor.getIdsOfSelectedNodes(stmt.cont);
                                          var selectedIds = match$2[1];
                                          var idxFrom = {
                                            contents: undefined
                                          };
                                          var idxTo = {
                                            contents: undefined
                                          };
                                          Expln_utils_data.traverseTree([
                                                {
                                                  contents: false
                                                },
                                                {
                                                  contents: match$1.exprTyp.length
                                                }
                                              ], {
                                                TAG: /* Subtree */0,
                                                _0: match$1.root
                                              }, (function (param, node) {
                                                  if (node.TAG === /* Subtree */0) {
                                                    return node._0.children;
                                                  }
                                                  
                                                }), undefined, (function (param, node) {
                                                  var charsPassed = param[1];
                                                  var selectionIsOn = param[0];
                                                  if (node.TAG !== /* Subtree */0) {
                                                    var symbolIsHighlighted = Belt_SetInt.has(selectedIds, node.id);
                                                    if (selectionIsOn.contents && !symbolIsHighlighted) {
                                                      idxTo.contents = charsPassed.contents;
                                                    }
                                                    if (!selectionIsOn.contents && symbolIsHighlighted) {
                                                      idxFrom.contents = charsPassed.contents + 1 | 0;
                                                    }
                                                    charsPassed.contents = (charsPassed.contents + 1 | 0) + node.sym.length | 0;
                                                    selectionIsOn.contents = symbolIsHighlighted;
                                                  }
                                                  return idxTo.contents;
                                                }), undefined, undefined);
                                          var match$3 = idxFrom.contents;
                                          var match$4 = idxTo.contents;
                                          if (match$3 !== undefined) {
                                            if (match$4 !== undefined) {
                                              return [
                                                      match$3,
                                                      match$4
                                                    ];
                                            } else {
                                              return [
                                                      match$3,
                                                      MM_wrk_editor.contToStr(stmt.cont).length
                                                    ];
                                            }
                                          }
                                          
                                        }));
                                  Curry._1(onContEditRequested, undefined);
                                }),
                              title: "Edit",
                              children: Caml_option.some(React.createElement(Edit, {}))
                            }), React.createElement(Button, {
                              onClick: (function (param) {
                                  actUpdateSyntaxTree(function (treeData) {
                                        return {
                                                exprTyp: treeData.exprTyp,
                                                root: treeData.root,
                                                clickedNodeId: undefined,
                                                expLvl: treeData.expLvl
                                              };
                                      });
                                }),
                              title: "Unselect",
                              children: Caml_option.some(React.createElement(CancelOutlined, {}))
                            })), Belt_Option.isSome(copiedToClipboard) ? "Copied to the clipboard." : null);
        };
        var rndCont = function (param) {
          if (stmt.contEditMode) {
            var windowWidth = window.innerWidth;
            var domElem = labelRef.current;
            var labelWidth = !(domElem == null) ? domElem.offsetWidth : 0;
            var partial_arg = actContEditCancel;
            var partial_arg$1 = actContEditDone;
            return React.createElement(Expln_React_Row.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            inputRef: Caml_option.some(stmtTextFieldRef),
                            value: state.newText,
                            size: "small",
                            style: {
                              width: String((windowWidth - 215 | 0) - labelWidth | 0) + "px"
                            },
                            multiline: true,
                            onChange: (function (evt) {
                                var selectionStart = evt.target.selectionStart;
                                var value = evt.target.value;
                                var prevLen = state.newText.length;
                                var newLen = value.length;
                                var newText;
                                if ((prevLen + 1 | 0) === newLen && selectionStart > 1 && " " === value.charAt(selectionStart - 1 | 0)) {
                                  var pos = selectionStart - 1 | 0;
                                  var prevBefore = state.newText.substring(0, pos);
                                  var newBefore = value.substring(0, pos);
                                  var prevAfter = after(state.newText, pos - 1 | 0);
                                  var newAfter = after(value, pos);
                                  if (prevBefore === newBefore && prevAfter === newAfter) {
                                    var lastSymbol = getLastSymbol(newBefore);
                                    var closingParen = Belt_HashMapString.get(parensMap, lastSymbol);
                                    if (closingParen !== undefined) {
                                      var newText$1 = newBefore + "  " + closingParen + newAfter;
                                      Curry._1(setNewTextCursorPosition, (function (param) {
                                              return selectionStart;
                                            }));
                                      newText = newText$1;
                                    } else {
                                      newText = value;
                                    }
                                  } else {
                                    newText = value;
                                  }
                                } else {
                                  newText = value;
                                }
                                Curry._1(setState, (function (__x) {
                                        return setNewText(__x, newText);
                                      }));
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                              }),
                            inputProps: {
                              style: {
                                fontFamily: "monospace"
                              }
                            },
                            autoFocus: true,
                            title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                          }), rndIconButton(React.createElement(Save, {}), actContEditDone, state.newText.trim() !== "", "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actContEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
          }
          var match = stmt.cont;
          var textIsSelected;
          textIsSelected = match.TAG === /* Text */0 ? false : Belt_Option.isSome(match._0.clickedNodeId);
          var elems = [React.createElement(Paper, {
                  onClick: editStmtsByLeftClick ? (function (param) {
                        return leftClickHnd(onContEditRequested, param);
                      }) : (function (param) {
                        return altLeftClickHnd(onContEditRequested, param);
                      }),
                  style: {
                    backgroundColor: Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) ? "rgb(255,230,230)" : "rgb(255,255,235)",
                    fontFamily: "monospace",
                    fontSize: "1.3em",
                    padding: "1px 10px"
                  },
                  title: editStmtsByLeftClick ? "<left-click> to change, Alt+<left-click> to select" : "Alt + <left-click> to change, <left-click> to select",
                  children: Caml_option.some(rndContText(stmt.cont, (function (idx) {
                              Curry._1(setSyntaxTreeWasRequested, (function (param) {
                                      return idx;
                                    }));
                            }), actTreeNodeClicked, editStmtsByLeftClick, true, undefined))
                })];
          if (Belt_Option.isSome(syntaxTreeWasRequested)) {
            elems.push(React.createElement("span", undefined, "Building a syntax tree..."));
          }
          if (textIsSelected) {
            elems.push(rndSelectionButtons(undefined));
          }
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(elems)
                    });
        };
        var rndTyp = function (param) {
          if (stmt.typEditMode) {
            return React.createElement(FormControl, {
                        size: "small",
                        children: Caml_option.some(React.createElement(Select, {
                                  value: "",
                                  onChange: (function (param) {
                                      return Expln_React_common.evt2str(actTypEditDone, param);
                                    }),
                                  children: Caml_option.some(null)
                                }, React.createElement(MenuItem, {
                                      value: "e",
                                      children: "H"
                                    }), React.createElement(MenuItem, {
                                      value: "p",
                                      children: "P"
                                    })))
                      });
          }
          var match = stmt.typ;
          var typStr = match ? "P" : "H";
          return React.createElement("span", {
                      style: {
                        cursor: "pointer",
                        fontWeight: "bold"
                      },
                      title: "Alt+<left-click> to change statement type. Left-click to show/hide the justification for provable.",
                      onClick: (function (evt) {
                          altLeftClickHnd(onTypEditRequested, evt);
                          leftClickHnd(actToggleInfoExpanded, evt);
                        })
                    }, typStr.toUpperCase());
        };
        var rndJstf = function (param) {
          if (stmt.jstfEditMode) {
            var partial_arg = actJstfEditCancel;
            var partial_arg$1 = actJstfEditDone;
            return React.createElement(Expln_React_Row.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: state.newText,
                            label: "Justification",
                            size: "small",
                            style: {
                              width: "600px"
                            },
                            multiline: true,
                            onChange: (function (param) {
                                return Expln_React_common.evt2str(actNewTextUpdated, param);
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                              }),
                            autoFocus: true,
                            title: "Enter to save, Esc to cancel"
                          }), rndIconButton(React.createElement(Save, {}), actJstfEditDone, true, "Save, Enter", undefined, undefined), rndIconButton(React.createElement(CancelOutlined, {}), actJstfEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined));
          }
          var jstfText = stmt.jstfText === "" ? " " : stmt.jstfText;
          var padding = jstfText.trim() === "" ? "10px 30px" : "3px";
          return React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Paper, {
                          onClick: (function (param) {
                              return leftClickHnd(onJstfEditRequested, param);
                            }),
                          style: {
                            marginTop: "5px",
                            padding: padding
                          },
                          title: "<left-click> to change",
                          children: Caml_option.some(jstfText)
                        }), jstfText.trim() === "" ? null : React.createElement("span", undefined, rndIconButton(React.createElement(DeleteForever, {}), actJstfDeleted, undefined, "Clear", Caml_option.some(undefined), undefined)));
        };
        var rndJstfVisualization = function (param) {
          if (visualizationIsOn && Belt_Option.isSome(wrkCtx) && Belt_Option.isSome(stmt.proofTreeDto) && Belt_Option.isSome(stmt.src)) {
            return React.createElement(make, {
                        wrkCtx: Belt_Option.getExn(wrkCtx),
                        proofTreeDto: Belt_Option.getExn(stmt.proofTreeDto),
                        jstfText: stmt.jstfText,
                        src: Belt_Option.getExn(stmt.src),
                        typeColors: typeColors,
                        preCtxColors: preCtxColors,
                        wrkCtxColors: wrkCtxColors
                      });
          } else {
            return null;
          }
        };
        var rndInfoBody = function (param) {
          if (stmt.typ === /* P */1 && (state.infoExpanded || stmt.jstfEditMode)) {
            return React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, rndJstf(undefined), rndJstfVisualization(undefined));
          } else {
            return null;
          }
        };
        return React.createElement("table", {
                    style: {
                      cursor: Belt_Option.isSome(syntaxTreeWasRequested) ? "wait" : "",
                      margin: "-2px"
                    }
                  }, React.createElement("tbody", undefined, React.createElement("tr", {
                            style: {
                              verticalAlign: "top"
                            }
                          }, React.createElement("td", undefined, rndProofStatus(stmt.proofStatus, "Proof is ready, left-click to generate compressed proof", "Justification for this statement is correct", "Justification cannot be determined automatically. Click to debug.", "Justification is incorrect. Click to debug.", param.onGenerateProof, onDebug, onDebug, undefined)), React.createElement("td", undefined, rndLabel(undefined)), React.createElement("td", undefined, rndTyp(undefined)), React.createElement("td", undefined, rndCont(undefined))), React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndInfoBody(undefined)))));
      }), propsAreSame);

exports.rndProofStatus = rndProofStatus;
exports.make = make$1;
exports.rndContText = rndContText;
/* make Not a pure module */
